import { Action } from '@ngrx/store';

import { AuthenticationActionTypes, Login } from '@actions/authentication.actions';
import { FetchFromLocalStorage } from '@common/helpers/fetch-from-local-storage.helper';
import { AuthenticationState } from 'state';

export const initialState: AuthenticationState = FetchFromLocalStorage('authentication') || {
    isAuthenticated: false
};

export function authenticationReducer(state = initialState, action: Action): AuthenticationState {
    switch (action.type) {
        case AuthenticationActionTypes.Login: {
            const specificAction = action as Login;
            return { ...state, isAuthenticated: true, loggedInUntil: specificAction.loggedInUntil };
        }

        case AuthenticationActionTypes.Logout: {
            return { ...state, isAuthenticated: false };
        }

        default: {
            return state;
        }
    }
}
